const initialState = {
    expandRouteMenu: false,
    isSideMenuNavigation: true,
    isAdminFetching: false,
    accessibleScreens: [],
    IsAdminView:false,
    isLibraryAdmin: false,
    accessDetails: "",
    assignedIIDArray:[],
    assignedInstitute:[]
}

// METHOD TO SET ADMIN FETCHING
const setAdminFetching = (state, action) => {
    return {
        ...state,
        isAdminFetching: action.adminFetching
    };
}

// METHOD TO SET FEEDBACK ADMIN DETAILS
const setFeedbackAdminDetails = (state, action) => {
    let accessDetails = action.apiResult;
    

    // return {
    //     ...state,
    //     accessDetails: accessDetails,
    // };
}

const setLibraryAdminDetails = (state, action) => {
    
    return {
        ...state,
        accessibleScreens: action.payload.accessibleScreens,
        accessDetails: action.payload.accessDetails,
        accessibleOperations:action.payload.accessibleOperations,
        isLibraryAdmin: action.payload.isAdmin
    };
}

const getAssignedIIDArray = (state, action) => {
	return {
		...state,
		iidArray: action.apiResult
	};
}

const getAssignedInstituteObject = (state, action) => {
	return {
		...state,
		multipleInstituteDetails: action.apiResult
	};
}

// eslint-disable-next-line import/no-anonymous-default-export
const RouteMenuReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'TOGGLE_ROUTE_MENU': return { ...state, expandRouteMenu: action.toggleFlag };
        case 'SET_SIDE_MENU_NAVIGATION': return { ...state, isSideMenuNavigation: action.sideMenuNavigation };
        case 'TOGGLE_CURRENT_VIEW' : return { ...state, IsAdminView: action.IsAdminView };
        case 'SET_ADMIN_FETCHING': return setAdminFetching(state, action);
        case 'SET_FEEDBACK_ADMIN_DETAILS': return setFeedbackAdminDetails(state, action);
        case 'ASSIGNED_INSTITUTE' : return { ...state, assignedInstitute:action.assignedInstitute};
        case 'ASSIGNED_IID_ARRAY' : return{...state,assignedIIDArray:action.assignedIIDArray };
        case 'SET_LIBRARY_ADMIN_DETAILS' : return setLibraryAdminDetails(state,action);
        case 'GET_ASSIGNED_INSTITUTE_ARRAY' : return getAssignedIIDArray(state,action);
        case 'GET_ASSIGNED_INSTITUTE_OBJECT' : return getAssignedInstituteObject(state,action);
        // case 'SET_LIBRARY_ADMIN_DETAILS' : return { ...state, accessibleScreens: action.payload.accessibleScreens}
        default: return state;
    }
};

export default RouteMenuReducer;